import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Title.svg'
import _imports_1 from '@/assets/NeinNeinNein_large.webm'
import _imports_2 from '@/assets/NeinNeinNein_small.webm'


const _withScopeId = n => (_pushScopeId("data-v-0722047a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "classicalMoves" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "remaining classical moves:", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "video/webm",
  media: "(-webkit-min-device-pixel-ratio: 2)"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_2,
  type: "video/webm"
}, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Specials Game Rules", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GameBoard = _resolveComponent("GameBoard")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_GameExplanation = _resolveComponent("GameExplanation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("img", {
        src: _imports_0,
        height: "50",
        width: "144",
        alt: "q4 Logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toMenu'))),
        title: "Go to menu",
        role: "button"
      }),
      _createElementVNode("h1", {
        class: _normalizeClass({ player1: _ctx.state.next_player })
      }, " Next player: " + _toDisplayString(_ctx.getCurrentPlayerColor(_ctx.state.next_player)), 3),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.expl.open()))
      }, "Help")
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_GameBoard, {
        state: _ctx.state,
        onPlaceClassical: _ctx.placeClassical,
        onPlaceSpace: _ctx.placeSpace,
        onPlaceColor: _ctx.placeColor,
        onManualCollapse: _ctx.manualCollapse
      }, null, 8, ["state", "onPlaceClassical", "onPlaceSpace", "onPlaceColor", "onManualCollapse"]),
      (_ctx.state.collapsesBeforeMove < Infinity)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass({ outOfMoves: _ctx.state.playerAllowedCollapses === 0 })
          }, " You have performed " + _toDisplayString(_ctx.state.playerAllowedCollapses) + " out of " + _toDisplayString(_ctx.state.collapsesBeforeMove) + " allowed collapses before your move. ", 3))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("span", {
          class: _normalizeClass({ low: _ctx.state.playerDoubleAllowedClassical[0] <= 2 }),
          style: {"color":"red"}
        }, "red: " + _toDisplayString(_ctx.state.playerDoubleAllowedClassical[0] / 2), 3),
        _hoisted_4,
        _createElementVNode("span", {
          class: _normalizeClass({ low: _ctx.state.playerDoubleAllowedClassical[1] <= 2 }),
          style: {"color":"blue"}
        }, "blue: " + _toDisplayString(_ctx.state.playerDoubleAllowedClassical[1] / 2), 3)
      ])
    ]),
    _createVNode(_component_Alert, {
      title: "Illegal move!",
      message: "That move is illegal! It cannot be completed in any of the possible world states.",
      ref: "modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", {
          autoplay: "",
          preload: "",
          width: "320",
          height: "431",
          ref: "video",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.video.play())),
          style: {"cursor":"pointer"}
        }, _hoisted_7, 512)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Alert, {
      title: "Game Won!",
      message: 
      'Player ' +
        _ctx.getCurrentPlayerColor(_ctx.state.winner?.player1) +
        ' has won in all possible states of the game!'
    ,
      shouldOpen: _ctx.state.winner !== undefined,
      ref: "alertWin"
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toMenu')))
        }, "New Game"),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs.alertWin.showModal = false))
        }, "Continue")
      ]),
      _: 1
    }, 8, ["message", "shouldOpen"]),
    _createVNode(_component_GameExplanation, { ref: "expl" }, {
      default: _withCtx(() => [
        (_ctx.state.collapsingIsMove || _ctx.state.collapsesBeforeMove < Infinity)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_8,
              (_ctx.state.collapsingIsMove)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Collapsing a piece counts as a players move. "))
                : _createCommentVNode("", true),
              (_ctx.state.collapsesBeforeMove < Infinity)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Each player is allowed to perform " + _toDisplayString(_ctx.state.collapsesBeforeMove) + " collapses before performing their move. ", 1))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ], 64))
}